module.exports = __webpack_public_path__ + "static/media/rom12.43df7421.jpg";